import styled from 'styled-components';

const Wrapper = styled.section`
  min-height: 100vh;

  padding: 4rem 2rem;

  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.palette.neutral[50]};

  position: relative;

  @media (max-width: ${props => props.theme.layout.breakpoints.md}) {
    padding: 2rem;
  }
`;

export default Wrapper;
